module.exports = __webpack_public_path__ + "ad51aaf2dc85b29a00a40994825ba391.woff";